// extracted by mini-css-extract-plugin
export var messageSideLeft = "_s6-1";
export var stateContainer = "_s6-0";